/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FilesystemPermissionUpdate
 */
export interface FilesystemPermissionUpdate {
    /**
     * 
     * @type {string}
     * @memberof FilesystemPermissionUpdate
     */
    path: string;
    /**
     * 
     * @type {boolean}
     * @memberof FilesystemPermissionUpdate
     */
    readOnly?: boolean;
    /**
     * 
     * @type {number}
     * @memberof FilesystemPermissionUpdate
     */
    user?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FilesystemPermissionUpdate
     */
    group?: number | null;
}

export function FilesystemPermissionUpdateFromJSON(json: any): FilesystemPermissionUpdate {
    return FilesystemPermissionUpdateFromJSONTyped(json, false);
}

export function FilesystemPermissionUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): FilesystemPermissionUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'path': json['path'],
        'readOnly': !exists(json, 'read_only') ? undefined : json['read_only'],
        'user': !exists(json, 'user') ? undefined : json['user'],
        'group': !exists(json, 'group') ? undefined : json['group'],
    };
}

export function FilesystemPermissionUpdateToJSON(value?: FilesystemPermissionUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'path': value.path,
        'read_only': value.readOnly,
        'user': value.user,
        'group': value.group,
    };
}


